
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/summit/speakers/[slug]",
      function () {
        return require("private-next-pages/summit/speakers/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/summit/speakers/[slug]"])
      });
    }
  